// extracted by mini-css-extract-plugin
export default {"section-container":"PieChartSection_section-container__obmlN"};